<script lang="ts">
	interface Props {
		logoSrc?: string;
		tagline?: string;
	}

	let { logoSrc = '/koru.svg', tagline = 'Modern Git Server & Collaboration Platform' }: Props =
		$props();
</script>

<div
	class="bg-brand-950 relative hidden h-full w-full items-center lg:grid lg:w-1/2 dark:bg-white/5"
>
	<div class="z-1 flex items-center justify-center">
		<!-- Grid decoration top-right -->
		<div class="absolute right-0 top-0 -z-1 w-full max-w-[250px] xl:max-w-[450px]">
			<svg
				width="450"
				height="254"
				viewBox="0 0 450 254"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M0.50555 45.1131L450 45.1132L450 44.6073L0.50555 44.6072L0.50555 45.1131Z"
					fill="url(#paint0_linear_3005_4084)"
					fill-opacity="0.3"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M205.546 253.529L205.546 -2.13709e-05L205.04 -2.1392e-05L205.04 253.529L205.546 253.529Z"
					fill="url(#paint1_linear_3005_4084)"
					fill-opacity="0.3"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M0.505546 97.2164L450 97.2165L450 96.7106L0.505546 96.7106L0.505546 97.2164Z"
					fill="url(#paint2_linear_3005_4084)"
					fill-opacity="0.3"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M256.806 253.529L256.806 -1.68895e-05L256.3 -1.69106e-05L256.3 253.529L256.806 253.529Z"
					fill="url(#paint3_linear_3005_4084)"
					fill-opacity="0.3"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M0.505837 253.529L0.505859 -3.9296e-05L0 -3.93171e-05L-2.21642e-05 253.529L0.505837 253.529Z"
					fill="url(#paint4_linear_3005_4084)"
					fill-opacity="0.3"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M0.505541 149.321L450 149.321L450 148.815L0.505541 148.815L0.505541 149.321Z"
					fill="url(#paint5_linear_3005_4084)"
					fill-opacity="0.3"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M308.066 253.529L308.066 -1.24083e-05L307.56 -1.24294e-05L307.56 253.529L308.066 253.529Z"
					fill="url(#paint6_linear_3005_4084)"
					fill-opacity="0.3"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M51.7662 253.529L51.7662 -3.48147e-05L51.2603 -3.48358e-05L51.2603 253.529L51.7662 253.529Z"
					fill="url(#paint7_linear_3005_4084)"
					fill-opacity="0.3"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M0.505537 201.424L450 201.424L450 200.918L0.505537 200.918L0.505537 201.424Z"
					fill="url(#paint8_linear_3005_4084)"
					fill-opacity="0.3"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M359.326 253.529L359.326 -7.92695e-06L358.82 -7.94806e-06L358.82 253.529L359.326 253.529Z"
					fill="url(#paint9_linear_3005_4084)"
					fill-opacity="0.3"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M103.026 253.529L103.026 -3.03334e-05L102.52 -3.03545e-05L102.52 253.529L103.026 253.529Z"
					fill="url(#paint10_linear_3005_4084)"
					fill-opacity="0.3"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M410.586 253.529L410.586 -3.44569e-06L410.08 -3.4668e-06L410.08 253.529L410.586 253.529Z"
					fill="url(#paint11_linear_3005_4084)"
					fill-opacity="0.3"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M154.286 253.529L154.286 -2.58521e-05L153.78 -2.58732e-05L153.78 253.529L154.286 253.529Z"
					fill="url(#paint12_linear_3005_4084)"
					fill-opacity="0.3"
				/>
				<rect
					width="50.7536"
					height="51.5982"
					transform="matrix(-1 -8.74228e-08 -8.74228e-08 1 358.821 45.1138)"
					fill="#B2B2B2"
					fill-opacity="0.08"
				/>
				<rect
					width="50.756"
					height="51.5985"
					transform="matrix(-1 -8.74228e-08 -8.74228e-08 1 307.559 97.2163)"
					fill="#B2B2B2"
					fill-opacity="0.08"
				/>
				<defs>
					<linearGradient
						id="paint0_linear_3005_4084"
						x1="277.872"
						y1="-9.94587e-06"
						x2="194.87"
						y2="235.867"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#B2B2B2" />
						<stop offset="1" stop-color="#B2B2B2" stop-opacity="0" />
					</linearGradient>
					<linearGradient
						id="paint1_linear_3005_4084"
						x1="277.872"
						y1="-9.94587e-06"
						x2="194.87"
						y2="235.867"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#B2B2B2" />
						<stop offset="1" stop-color="#B2B2B2" stop-opacity="0" />
					</linearGradient>
					<linearGradient
						id="paint2_linear_3005_4084"
						x1="277.872"
						y1="-9.94587e-06"
						x2="194.87"
						y2="235.867"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#B2B2B2" />
						<stop offset="1" stop-color="#B2B2B2" stop-opacity="0" />
					</linearGradient>
					<linearGradient
						id="paint3_linear_3005_4084"
						x1="277.872"
						y1="-9.94587e-06"
						x2="194.87"
						y2="235.867"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#B2B2B2" />
						<stop offset="1" stop-color="#B2B2B2" stop-opacity="0" />
					</linearGradient>
					<linearGradient
						id="paint4_linear_3005_4084"
						x1="277.872"
						y1="-9.94587e-06"
						x2="194.87"
						y2="235.867"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#B2B2B2" />
						<stop offset="1" stop-color="#B2B2B2" stop-opacity="0" />
					</linearGradient>
					<linearGradient
						id="paint5_linear_3005_4084"
						x1="277.872"
						y1="-9.94587e-06"
						x2="194.87"
						y2="235.867"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#B2B2B2" />
						<stop offset="1" stop-color="#B2B2B2" stop-opacity="0" />
					</linearGradient>
					<linearGradient
						id="paint6_linear_3005_4084"
						x1="277.872"
						y1="-9.94587e-06"
						x2="194.87"
						y2="235.867"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#B2B2B2" />
						<stop offset="1" stop-color="#B2B2B2" stop-opacity="0" />
					</linearGradient>
					<linearGradient
						id="paint7_linear_3005_4084"
						x1="277.872"
						y1="-9.94587e-06"
						x2="194.87"
						y2="235.867"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#B2B2B2" />
						<stop offset="1" stop-color="#B2B2B2" stop-opacity="0" />
					</linearGradient>
					<linearGradient
						id="paint8_linear_3005_4084"
						x1="277.872"
						y1="-9.94587e-06"
						x2="194.87"
						y2="235.867"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#B2B2B2" />
						<stop offset="1" stop-color="#B2B2B2" stop-opacity="0" />
					</linearGradient>
					<linearGradient
						id="paint9_linear_3005_4084"
						x1="277.872"
						y1="-9.94587e-06"
						x2="194.87"
						y2="235.867"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#B2B2B2" />
						<stop offset="1" stop-color="#B2B2B2" stop-opacity="0" />
					</linearGradient>
					<linearGradient
						id="paint10_linear_3005_4084"
						x1="277.872"
						y1="-9.94587e-06"
						x2="194.87"
						y2="235.867"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#B2B2B2" />
						<stop offset="1" stop-color="#B2B2B2" stop-opacity="0" />
					</linearGradient>
					<linearGradient
						id="paint11_linear_3005_4084"
						x1="277.872"
						y1="-9.94587e-06"
						x2="194.87"
						y2="235.867"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#B2B2B2" />
						<stop offset="1" stop-color="#B2B2B2" stop-opacity="0" />
					</linearGradient>
					<linearGradient
						id="paint12_linear_3005_4084"
						x1="277.872"
						y1="-9.94587e-06"
						x2="194.87"
						y2="235.867"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#B2B2B2" />
						<stop offset="1" stop-color="#B2B2B2" stop-opacity="0" />
					</linearGradient>
				</defs>
			</svg>
		</div>

		<!-- Grid decoration bottom-left (rotated 180deg) -->
		<!-- <div class="absolute bottom-0 left-0 -z-1 w-full max-w-[250px] rotate-180 xl:max-w-[450px]">
			<svg
				width="450"
				height="254"
				viewBox="0 0 450 254"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M0.50555 45.1131L450 45.1132L450 44.6073L0.50555 44.6072L0.50555 45.1131Z"
					fill="url(#paint0_linear_3005_4084_2)"
					fill-opacity="0.3"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M205.546 253.529L205.546 -2.13709e-05L205.04 -2.1392e-05L205.04 253.529L205.546 253.529Z"
					fill="url(#paint1_linear_3005_4084_2)"
					fill-opacity="0.3"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M0.505546 97.2164L450 97.2165L450 96.7106L0.505546 96.7106L0.505546 97.2164Z"
					fill="url(#paint2_linear_3005_4084_2)"
					fill-opacity="0.3"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M256.806 253.529L256.806 -1.68895e-05L256.3 -1.69106e-05L256.3 253.529L256.806 253.529Z"
					fill="url(#paint3_linear_3005_4084_2)"
					fill-opacity="0.3"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M0.505837 253.529L0.505859 -3.9296e-05L0 -3.93171e-05L-2.21642e-05 253.529L0.505837 253.529Z"
					fill="url(#paint4_linear_3005_4084_2)"
					fill-opacity="0.3"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M0.505541 149.321L450 149.321L450 148.815L0.505541 148.815L0.505541 149.321Z"
					fill="url(#paint5_linear_3005_4084_2)"
					fill-opacity="0.3"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M308.066 253.529L308.066 -1.24083e-05L307.56 -1.24294e-05L307.56 253.529L308.066 253.529Z"
					fill="url(#paint6_linear_3005_4084_2)"
					fill-opacity="0.3"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M51.7662 253.529L51.7662 -3.48147e-05L51.2603 -3.48358e-05L51.2603 253.529L51.7662 253.529Z"
					fill="url(#paint7_linear_3005_4084_2)"
					fill-opacity="0.3"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M0.505537 201.424L450 201.424L450 200.918L0.505537 200.918L0.505537 201.424Z"
					fill="url(#paint8_linear_3005_4084_2)"
					fill-opacity="0.3"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M359.326 253.529L359.326 -7.92695e-06L358.82 -7.94806e-06L358.82 253.529L359.326 253.529Z"
					fill="url(#paint9_linear_3005_4084_2)"
					fill-opacity="0.3"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M103.026 253.529L103.026 -3.03334e-05L102.52 -3.03545e-05L102.52 253.529L103.026 253.529Z"
					fill="url(#paint10_linear_3005_4084_2)"
					fill-opacity="0.3"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M410.586 253.529L410.586 -3.44569e-06L410.08 -3.4668e-06L410.80 253.529L410.586 253.529Z"
					fill="url(#paint11_linear_3005_4084_2)"
					fill-opacity="0.3"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M154.286 253.529L154.286 -2.58521e-05L153.78 -2.58732e-05L153.78 253.529L154.286 253.529Z"
					fill="url(#paint12_linear_3005_4084_2)"
					fill-opacity="0.3"
				/>
				<rect
					width="50.7536"
					height="51.5982"
					transform="matrix(-1 -8.74228e-08 -8.74228e-08 1 358.821 45.1138)"
					fill="#B2B2B2"
					fill-opacity="0.08"
				/>
				<rect
					width="50.756"
					height="51.5985"
					transform="matrix(-1 -8.74228e-08 -8.74228e-08 1 307.559 97.2163)"
					fill="#B2B2B2"
					fill-opacity="0.08"
				/>
				<defs>
					<linearGradient
						id="paint0_linear_3005_4084_2"
						x1="277.872"
						y1="-9.94587e-06"
						x2="194.87"
						y2="235.867"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#B2B2B2" />
						<stop offset="1" stop-color="#B2B2B2" stop-opacity="0" />
					</linearGradient>
					<linearGradient
						id="paint1_linear_3005_4084_2"
						x1="277.872"
						y1="-9.94587e-06"
						x2="194.87"
						y2="235.867"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#B2B2B2" />
						<stop offset="1" stop-color="#B2B2B2" stop-opacity="0" />
					</linearGradient>
					<linearGradient
						id="paint2_linear_3005_4084_2"
						x1="277.872"
						y1="-9.94587e-06"
						x2="194.87"
						y2="235.867"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#B2B2B2" />
						<stop offset="1" stop-color="#B2B2B2" stop-opacity="0" />
					</linearGradient>
					<linearGradient
						id="paint3_linear_3005_4084_2"
						x1="277.872"
						y1="-9.94587e-06"
						x2="194.87"
						y2="235.867"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#B2B2B2" />
						<stop offset="1" stop-color="#B2B2B2" stop-opacity="0" />
					</linearGradient>
					<linearGradient
						id="paint4_linear_3005_4084_2"
						x1="277.872"
						y1="-9.94587e-06"
						x2="194.87"
						y2="235.867"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#B2B2B2" />
						<stop offset="1" stop-color="#B2B2B2" stop-opacity="0" />
					</linearGradient>
					<linearGradient
						id="paint5_linear_3005_4084_2"
						x1="277.872"
						y1="-9.94587e-06"
						x2="194.87"
						y2="235.867"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#B2B2B2" />
						<stop offset="1" stop-color="#B2B2B2" stop-opacity="0" />
					</linearGradient>
					<linearGradient
						id="paint6_linear_3005_4084_2"
						x1="277.872"
						y1="-9.94587e-06"
						x2="194.87"
						y2="235.867"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#B2B2B2" />
						<stop offset="1" stop-color="#B2B2B2" stop-opacity="0" />
					</linearGradient>
					<linearGradient
						id="paint7_linear_3005_4084_2"
						x1="277.872"
						y1="-9.94587e-06"
						x2="194.87"
						y2="235.867"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#B2B2B2" />
						<stop offset="1" stop-color="#B2B2B2" stop-opacity="0" />
					</linearGradient>
					<linearGradient
						id="paint8_linear_3005_4084_2"
						x1="277.872"
						y1="-9.94587e-06"
						x2="194.87"
						y2="235.867"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#B2B2B2" />
						<stop offset="1" stop-color="#B2B2B2" stop-opacity="0" />
					</linearGradient>
					<linearGradient
						id="paint9_linear_3005_4084_2"
						x1="277.872"
						y1="-9.94587e-06"
						x2="194.87"
						y2="235.867"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#B2B2B2" />
						<stop offset="1" stop-color="#B2B2B2" stop-opacity="0" />
					</linearGradient>
					<linearGradient
						id="paint10_linear_3005_4084_2"
						x1="277.872"
						y1="-9.94587e-06"
						x2="194.87"
						y2="235.867"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#B2B2B2" />
						<stop offset="1" stop-color="#B2B2B2" stop-opacity="0" />
					</linearGradient>
					<linearGradient
						id="paint11_linear_3005_4084_2"
						x1="277.872"
						y1="-9.94587e-06"
						x2="194.87"
						y2="235.867"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#B2B2B2" />
						<stop offset="1" stop-color="#B2B2B2" stop-opacity="0" />
					</linearGradient>
					<linearGradient
						id="paint12_linear_3005_4084_2"
						x1="277.872"
						y1="-9.94587e-06"
						x2="194.87"
						y2="235.867"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#B2B2B2" />
						<stop offset="1" stop-color="#B2B2B2" stop-opacity="0" />
					</linearGradient>
				</defs>
			</svg>
		</div> -->

		<!-- Logo and tagline -->
		<div class="flex max-w-xs flex-col items-center">
			<a href="/#/" class="mb-4 block">
				<img src={logoSrc} alt="Logo" class="h-46 w-auto" />
			</a>
			<p class="text-center text-gray-400 dark:text-white/60">
				{tagline}
			</p>
		</div>
	</div>
</div>
